module.exports = __webpack_public_path__ + "static/media/reject.fdf0e5cf.svg";